import {StateChanges} from './stateChanges'
import {resetAfterFeatureChanges} from './resetState'
import {RunStates} from './runStates'

export default {
  [StateChanges.SET_REMOVED_FEATURES] (state, removedFeatures) {
    resetAfterFeatureChanges(state)
    state.removedFeatures = removedFeatures
  },
  [StateChanges.ENABLE_FEATURE_SET] (state, featureSetName) {
    resetAfterFeatureChanges(state)
    state.featureSettings[featureSetName].active = true
  },
  [StateChanges.DISABLE_FEATURE_SET] (state, featureSetName) {
    resetAfterFeatureChanges(state)
    state.featureSettings[featureSetName].active = false
  },
  [StateChanges.ENABLE_FEATURE] (state, {featureSetName, featureName}) {
    resetAfterFeatureChanges(state)
    const indexOfFeature = state.removedFeatures[featureSetName].indexOf(featureName)
    if (indexOfFeature > -1) {
      state.removedFeatures[featureSetName].splice(indexOfFeature, 1)
    }
  },
  [StateChanges.DISABLE_FEATURE] (state, {featureSetName, featureName}) {
    resetAfterFeatureChanges(state)
    const removalList = state.removedFeatures[featureSetName]
    if (!removalList.includes(featureName)) {
      removalList.push(featureName)
    }
  },
  [StateChanges.BATCH_FEATURE_CHANGES] (state, allFeatureChanges) {
    var featureSettings = JSON.parse(JSON.stringify(state.featureSettings))
    var removedFeatures = JSON.parse(JSON.stringify(state.removedFeatures))
    allFeatureChanges.forEach(featureChange => {
      if (featureChange.type === 'ENABLE_FEATURE_SET') {
        featureSettings[featureChange.object].active = true
      } else if (featureChange.type === 'DISABLE_FEATURE_SET') {
        featureSettings[featureChange.object].active = false
      } else if (featureChange.type === 'ENABLE_FEATURE') {
        const featureSetName = featureChange.object.featureSetName
        const featureName = featureChange.object.featureName
        const indexOfFeature = removedFeatures[featureSetName].indexOf(featureName)
        if (indexOfFeature > -1) {
          removedFeatures[featureSetName].splice(indexOfFeature, 1)
        }
      } else if (featureChange.type === 'DISABLE_FEATURE') {
        const featureSetName = featureChange.object.featureSetName
        const featureName = featureChange.object.featureName
        if (!(removedFeatures[featureSetName].includes(featureName))) {
          removedFeatures[featureSetName].push(featureName)
        }
      }
    })
    state.featureSettings = JSON.parse(JSON.stringify(featureSettings))
    state.removedFeatures = JSON.parse(JSON.stringify(removedFeatures))
    resetAfterFeatureChanges(state)
    state.updateFeaturesState = RunStates.COMPLETE
  }
}



// WEBPACK FOOTER //
// ./src/store/featureSettingsMutations.js